'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiError = function () {
  function ApiError(httpRequest, exception) {
    _classCallCheck(this, ApiError);

    this.httpRequest = httpRequest;
    this.exception = exception || null;
  }

  _createClass(ApiError, [{
    key: 'getMessage',
    value: function getMessage() {
      if (this.exception) {
        return this.exception.toString();
      }

      if (this.httpRequest && this.httpRequest.readyState === XMLHttpRequest.DONE) {
        return this.httpRequest.statusText;
      }

      return 'httpRequest did not complete';
    }
  }]);

  return ApiError;
}();

exports.default = ApiError;
module.exports = exports['default'];